import RSAsyncSelect from 'react-select/async';

export const AsyncSelect = <T, >({
  placeholder,
  onChange,
  loadOptions,
  getOptionLabel,
  getOptionValue,
}: {
  placeholder?: string,
  getOptionLabel: (_: T) => string,
  getOptionValue: (_: T) => string,
  onChange: (_:T | undefined) => void,
  loadOptions: (input: string) => Promise<Array<T>>,
}) => (
    <RSAsyncSelect<T>
      defaultOptions
      cacheOptions
      isMulti={false}
      className="filter-input"
      placeholder={placeholder}
      onChange={(value) => onChange(value || undefined)}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      loadOptions={(input) => loadOptions(input)}
    />
  );
